import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface SaveDialogResult {
  save: boolean;
  backup: boolean;
  fileName: string;
}

@Component({
  selector: 'app-save-dialog',
  templateUrl: './save-dialog.component.html',
})
export class SaveDialogComponent implements OnInit {
  backup: FormControl = new FormControl(true as boolean, [Validators.required]);
  fileName: FormControl = new FormControl('', [Validators.required]);

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<SaveDialogComponent>) {}

  ngOnInit(): void {
    this.setFileName();
    this.subscribeBackupValueChange();
  }

  close() {
    this.dialogRef.close(this.buildDialogResult(true, this.fileName.value));
  }

  cancel() {
    this.dialogRef.close(this.buildDialogResult(false, ''));
  }

  getFormError() {
    if (this.fileName.hasError('required')) return 'El campo no puede estar vacío';
    return '';
  }

  private buildDialogResult(save: boolean, filename: string): SaveDialogResult {
    return {
      save: save,
      backup: this.backup.value,
      fileName: filename,
    };
  }

  private generateFileName(): string {
    const now: Date = new Date();
    const year: string = now.getFullYear().toString();
    const month: string = (now.getMonth() + 1).toString().padStart(2, '0');
    const day: string = now.getDate().toString().padStart(2, '0');
    const hours: string = now.getHours().toString().padStart(2, '0');
    const minutes: string = now.getMinutes().toString().padStart(2, '0');
    const seconds: string = now.getSeconds().toString().padStart(2, '0');

    return `${year}${month}${day}${hours}${minutes}${seconds}-config`;
  }

  private setFileName() {
    this.fileName.setValue(this.generateFileName());
  }

  private subscribeBackupValueChange() {
    this.backup.valueChanges.subscribe((backup) => {
      backup ? this.fileName.enable() : this.fileName.disable();
    });
  }
}
